import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import HeroBgImage from '../../assets/images/heroBgImage.png'

export default function Hero() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="bg-gray-900">
      <div className="relative isolate overflow-hidden pt-14">
        <img
          alt=""
          src={HeroBgImage}
          className="absolute inset-0 -z-10 size-full object-cover"
          style={{
            filter:
              "sepia(50%) blur(3px) opacity(25%) saturate(10%) hue-rotate(270deg) brightness(30%) contrast(120%)"
          }}
          onContextMenu={(e) => e.preventDefault()}
        />
        
        {/* Hero Content */}
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
            <div className="text-center">
              <h1 className="text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">
                Custom-Built Solutions for Complex Technical Challenges
              </h1>
              <p className="mt-8 text-pretty text-lg font-medium text-gray-400 sm:text-xl/8">
                Atticus Labs engineers bespoke software solutions from the ground up—no templates, 
                no off-the-shelf plugins. From rapid prototyping to mission-critical systems with 
                regulatory compliance, real-time processing, and AI/ML integration, we build exactly 
                what your technical challenge demands.
              </p>
              <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
                <span className="inline-flex items-center px-4 py-2 bg-white/10 rounded-full text-white">
                  <svg className="w-4 h-4 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  </svg>
                  Custom Engineering
                </span>
                <span className="inline-flex items-center px-4 py-2 bg-white/10 rounded-full text-white">
                  <svg className="w-4 h-4 mr-2 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  Built From Scratch
                </span>
                <span className="inline-flex items-center px-4 py-2 bg-white/10 rounded-full text-white">
                  <svg className="w-4 h-4 mr-2 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                  Rapid Prototyping
                </span>
              </div>
              <div className="mt-10 flex items-center justify-center gap-x-6">
                <button
                  onClick={() => {
                    const scroller = require('react-scroll').scroller;
                    scroller.scrollTo('services', { smooth: true, duration: 500, offset: -70 });
                  }}
                  className="rounded-md bg-atticusPink-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-atticusPink-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-atticusPink-600"
                >
                  See Our Services
                </button>
                <button 
                  onClick={() => {
                    const scroller = require('react-scroll').scroller;
                    scroller.scrollTo('contact', { smooth: true, duration: 500, offset: -70 });
                  }}
                  className="text-sm/6 font-semibold text-white hover:text-gray-200"
                >
                  Discuss Your Project <span aria-hidden="true">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
